export enum StytchEmailTemplate {
  ResetPassword = 'evisort_custom_password_reset_template',
}
